exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#visitor {\n  width: 100%;\n}\n#visitor .v-application--wrap {\n  min-height: auto;\n}", ""]);

// exports
